import { t } from '@avalara/bat-apps-shared/i18n';
import FormInput from '../../containers/shared/forms/form-input';
import FormSelect from '../../containers/shared/forms/form-select';
import { FlexContainerRowInner } from '../styled/skylab/page';
import { useFetchRegionsAndCountries } from './hooks';
import PasswordInput from './password-input';

type Props = {
  isObapiSignup?: boolean;
};

const CreateAccountForm = ({ isObapiSignup = false }: Props) => {
  const { formattedCountries, formattedRegions } = useFetchRegionsAndCountries();
  return (
    <form className='pad-all-xs'>
      <FlexContainerRowInner>
        <fieldset>
          <FormInput fieldName='firstName' placeholder={t('client.placeholders.first-name')} />
        </fieldset>
        <fieldset>
          <FormInput fieldName='lastName' placeholder={t('client.placeholders.last-name')} />
        </fieldset>
      </FlexContainerRowInner>
      <fieldset>
        <FormInput fieldName='companyName' placeholder={t('client.placeholders.company-name')} />
      </fieldset>
      <fieldset>
        <FormInput fieldName='street1' placeholder={t('client.labels.primary-business-address')} />
      </fieldset>
      <fieldset>
        <FormInput fieldName='city' placeholder={t('client.labels.city')} />
      </fieldset>
      <FlexContainerRowInner>
        <fieldset>
          <FormSelect fieldName='state' fieldValues={formattedRegions} />
        </fieldset>
        <fieldset>
          <FormInput fieldName='postalCode' placeholder={t('client.placeholders.zip-postal-code')} />
        </fieldset>
      </FlexContainerRowInner>
      <fieldset>
        <FormSelect fieldName='country' fieldValues={formattedCountries} />
      </fieldset>
      <fieldset>
        <FormInput fieldName='phone' placeholder={t('client.labels.phone')} />
      </fieldset>
      <fieldset>
        <FormInput fieldName='email' placeholder={t('client.placeholders.email-username')} type='email' />
      </fieldset>
      {isObapiSignup && <PasswordInput />}
    </form>
  );
};

export default CreateAccountForm;
